module.exports = __webpack_public_path__ + "static/media/proximanova-regular-webfont.418203e5.woff2";